const DB_NAME = 'easy-editor-cache'
const STORE_NAME = 'feature_cache'
const DB_VERSION = 1

let dbPromise = null

function openDb() {
  if (dbPromise) return dbPromise
  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = (event) => {
      const db = event.target.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }
    request.onsuccess = (event) => resolve(event.target.result)
    request.onerror = (event) => {
      dbPromise = null
      reject(event.target.error)
    }
  })
  return dbPromise
}

export function _resetDbForTests() {
  dbPromise = null
}

export async function saveFeature(provider, recordId, data) {
  const db = await openDb()
  const plainData = JSON.parse(JSON.stringify(data))
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    const store = tx.objectStore(STORE_NAME)
    store.put(plainData, `${provider}_${recordId}`)
    tx.oncomplete = () => resolve()
    tx.onerror = (event) => reject(event.target.error)
    tx.onabort = (event) => reject(event.target.error)
  })
}

export async function loadFeature(provider, recordId) {
  const db = await openDb()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const store = tx.objectStore(STORE_NAME)
    const request = store.get(`${provider}_${recordId}`)
    request.onsuccess = (event) => resolve(event.target.result ?? null)
    request.onerror = (event) => reject(event.target.error)
  })
}
